export enum EntityStoreKey {
  terms = 'terms',
}
